import Vue from 'vue';
import Router from 'vue-router';
import UserSession from "@/service/UserSession";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: () => import('./views/Splash'),
        },
        {
            path: '/installations/disposals/:id/eak',
            name: 'Disposal Installations',
            component: () => import('./views/Installations/Disposal/EAK')
        },
        {
            path: '/installations/disposals/types/:id/eak',
            name: 'Disposal Types',
            component: () => import('./views/Installations/Disposal/Types/EAK')
        },
        {
            path: '/chemicals',
            name: 'Chemicals',
            component: () => import('./views/Chemicals/List')
        },
        {
            path: '/chemicals/:id',
            name: 'SingleChemical',
            component: () => import('./views/Chemicals/Single')
        },
        {
            path: '/change_password',
            name: 'ChangePassword',
            component: () => import('./components/Users/ChangePassword')
        },
        {
            path: '/reset_password',
            name: 'ResetPassword',
            component: () => import('./components/Users/ResetPassword')
        },
        {
            path: '/logout',
            name: 'Logout',
            component: () => import('./components/Users/Logout')
        },
        {
            path: '/login_as',
            name: 'LoginAs',
            component: () => import('./components/Users/LoginAs')
        },
        {
            path: '/oauth2/authorize',
            name: 'Oauth2',
            component: () => import('./components/Users/Oauth2')
        },
        {
            path: '/view_for',
            name: 'ViewFor',
            component: () => import('./components/Users/ViewFor')
        },
        {
            path: '/',
            name: 'EverythingElse',
            component: () => import('./components/Shared/Frame.vue'),
            children: [
                {
                    path: '/dashboard',
                    name: 'Dashboard',
                    component: () => import('./views/Dashboard')
                },
                {
                    path: '/profile/:userId',
                    name: 'Profile',
                    component: () => import('./views/Users/Profile.vue'),
                    props: true
                },
                {
                    path: '/organization/:id?',
                    name: 'Organization',
                    component: () => import('./views/Organization')
                },
                {
                    path: '/chemical/bulk-import',
                    name: 'Chemicals Bulk Import',
                    component: () => import('./views/Chemicals/BulkImport.vue')
                },
                {
                    path: '/chemical/bulk-import-global-status',
                    name: 'Chemicals Bulk Import Global Status',
                    component: () => import('./views/Chemicals/BulkImportGlobalStatus.vue')
                },
                {
                    path: '/demo/dashboard',
                    name: 'Demo Dashboard',
                    component: () => import('./components/Dashboard.vue')
                },
                {
                    path: '/demo/sample',
                    name: 'sample',
                    component: () => import('./components/SampleDemo.vue')
                },
                {
                    path: '/demo/forms',
                    name: 'forms',
                    component: () => import('./components/FormsDemo.vue')
                },
                {
                    path: '/demo/data',
                    name: 'data',
                    component: () => import('./components/DataDemo.vue')
                },
                {
                    path: '/demo/panels',
                    name: 'panels',
                    component: () => import('./components/PanelsDemo.vue')
                },
                {
                    path: '/demo/overlays',
                    name: 'overlays',
                    component: () => import('./components/OverlaysDemo.vue')
                },
                {
                    path: '/demo/menus',
                    component: () => import('./components/MenusDemo.vue'),
                    children: [
                        {
                            path: '',
                            component: () => import('./components/menu/PersonalDemo.vue')
                        },
                        {
                            path: '/demo/menus/seat',
                            component: () => import('./components/menu/SeatDemo.vue')
                        },
                        {
                            path: '/demo/menus/payment',
                            component: () => import('./components/menu/PaymentDemo.vue')
                        },
                        {
                            path: '/demo/menus/confirmation',
                            component: () => import('./components/menu/ConfirmationDemo.vue')
                        }
                    ]
                },
                {
                    path: '/demo/messages',
                    name: 'messages',
                    component: () => import('./components/MessagesDemo.vue')
                },
                {
                    path: '/demo/charts',
                    name: 'charts',
                    component: () => import('./components/ChartsDemo.vue')
                },
                {
                    path: '/demo/misc',
                    name: 'misc',
                    component: () => import('./components/MiscDemo.vue')
                },
                {
                    path: '/demo/empty',
                    name: 'empty',
                    component: () => import('./components/EmptyPage.vue')
                }
            ]
        }
    ],
    scrollBehavior() {
        return {x: 0, y: 0};
    }
});

const userSession = new UserSession(localStorage);

router.beforeEach((to, from, next) => {

    if (to.name === 'Home'
        || to.name === 'LoginAs'
        || to.name === 'ChangePassword'
        || to.name === 'ResetPassword'
        || to.name === 'Logout'
        || to.name === 'SingleChemical'
        || to.name === 'Chemicals') {
        next();
    } else if (userSession.refreshTokenIsMissing || userSession.refreshTokenHasExpired) {
        next({name: 'Home', query: {continue: decideContinueLocation(to)}});
    } else {
        next();
    }
})

export default router;

// Decides the continue location after authentication is completed. Could be `to.fullPath` instead of `location.href`,
// but since we need to authenticate to multiple domains, we need the full url so we can get back to the initial domain.
function decideContinueLocation() {
    return location.href;
}
